import useSWR from 'swr';
import { ReportPositions } from '../types';

export const useReportPositions = (clubSlug?: string | null, mandantId?: number | null) =>
    useSWR<{ data: ReportPositions }>(
        clubSlug && mandantId ? [`invoice/${clubSlug}/reports/positions`, { mandant_id: mandantId }] : null
    );
